// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gvmse","inputWrap":"Table_inputWrap__IcXLU","col":"Table_col__NJvLj","bmiTooltip":"Table_bmiTooltip__2LZGH"};